module.exports = __webpack_public_path__ + "img/Trion S1 3D Lidar Scanner.cc07f2f.png";